import { NavigationLink } from '../types/navigationLink';
import { CONTACT_URL } from './contactData';

export const ROUTE_URLS = {
  home: '/',
  forRestaurants: '/for-restaurants',
  // pricing: '/pricing',
  faq: '/faq',
  privacyPolicy: '/privacy-policy',
  termsAndConditions: '/terms',
};

export const SECTION_IDS = {
  hero: 'hero',
  about: 'about',
  aboutMe: 'about-me',
  services: 'services',
  restaurant: 'restaurant',
  portfolio: 'portfolio',
  contact: 'contact',
};

export const FOR_RESTAURANTS_SECTION_IDS = {
  hero: 'hero',
  beforeAfter: 'before-after',
  howItWorks: 'how-it-works',
  services: 'services',
  demo: 'demo',
  benefits: 'benefits',
  pricing: 'pricing',
  contact: 'contact',
  cta: 'cta',
  // challenges: 'challenges',
  // solutions: 'solutions',
  // localSupport: 'local-support',
};

export const FAQ_SECTION_IDS = {
  general: 'general',
  restaurant: 'restaurant',
  pricing: 'pricing',
};

export const ANCHOR_URLS = {
  hero: ROUTE_URLS.home + '#' + SECTION_IDS.hero,
  about: ROUTE_URLS.home + '#' + SECTION_IDS.about,
  aboutMe: ROUTE_URLS.home + '#' + SECTION_IDS.aboutMe,
  services: ROUTE_URLS.home + '#' + SECTION_IDS.services,
  portfolio: ROUTE_URLS.home + '#' + SECTION_IDS.portfolio,
  contact: ROUTE_URLS.home + '#' + SECTION_IDS.contact,
  forRestaurantsHero: ROUTE_URLS.forRestaurants + '#' + FOR_RESTAURANTS_SECTION_IDS.hero,
  forRestaurantsBeforeAfter:
    ROUTE_URLS.forRestaurants + '#' + FOR_RESTAURANTS_SECTION_IDS.beforeAfter,
  forRestaurantsHowItWorks:
    ROUTE_URLS.forRestaurants + '#' + FOR_RESTAURANTS_SECTION_IDS.howItWorks,
  forRestaurantsServices: ROUTE_URLS.forRestaurants + '#' + FOR_RESTAURANTS_SECTION_IDS.services,
  forRestaurantsDemo: ROUTE_URLS.forRestaurants + '#' + FOR_RESTAURANTS_SECTION_IDS.demo,
  forRestaurantsBenefits: ROUTE_URLS.forRestaurants + '#' + FOR_RESTAURANTS_SECTION_IDS.benefits,
  forRestaurantsPricing: ROUTE_URLS.forRestaurants + '#' + FOR_RESTAURANTS_SECTION_IDS.pricing,
  forRestaurantsContact: ROUTE_URLS.forRestaurants + '#' + FOR_RESTAURANTS_SECTION_IDS.contact,
  forRestaurantsCta: ROUTE_URLS.forRestaurants + '#' + FOR_RESTAURANTS_SECTION_IDS.cta,
  // forRestaurantsChallenges:
  //   ROUTE_URLS.forRestaurants + '#' + FOR_RESTAURANTS_SECTION_IDS.challenges,
  // forRestaurantsSolutions: ROUTE_URLS.forRestaurants + '#' + FOR_RESTAURANTS_SECTION_IDS.solutions,
  // forRestaurantsLocalSupport:
  //   ROUTE_URLS.forRestaurants + '#' + FOR_RESTAURANTS_SECTION_IDS.localSupport,
  generalFaq: ROUTE_URLS.faq + '#' + FAQ_SECTION_IDS.general,
  restaurantFaq: ROUTE_URLS.faq + '#' + FAQ_SECTION_IDS.restaurant,
  pricingFaq: ROUTE_URLS.faq + '#' + FAQ_SECTION_IDS.pricing,
};

export const EXTERNAL_URLS = {
  clientIntake: 'https://0p7dk6t5dog.typeform.com/to/YguzBq4w',
  linkedin: 'https://www.linkedin.com/in/katreid/',
  github: 'https://github.com/Alexreid95',
};

export const HEADER_NAV_LINKS: NavigationLink[] = [
  { label: 'Home', to: ROUTE_URLS.home },
  { label: 'For Restaurants', to: ROUTE_URLS.forRestaurants },
  // { label: 'Pricing', to: ROUTE_URLS.pricing },
  { label: 'FAQ', to: ROUTE_URLS.faq },
];

export const SOCIAL_LINKS: NavigationLink[] = [
  {
    label: 'WhatsApp',
    to: CONTACT_URL.whatsapp,
    iconName: 'FaWhatsapp',
    iconColour: 'whatsapp',
  },
  {
    label: 'LinkedIn',
    to: EXTERNAL_URLS.linkedin,
    iconName: 'FaLinkedin',
    iconColour: 'linkedin',
  },
  {
    label: 'GitHub',
    to: EXTERNAL_URLS.github,
    iconName: 'FaGithub',
    iconColour: 'github',
  },
];

export const FOOTER_RESOURCE_LINKS: NavigationLink[] = [
  { label: 'Client Intake Form', to: EXTERNAL_URLS.clientIntake },
];

export const FOOTER_QUICK_LINKS: NavigationLink[] = [
  { label: 'Home Page', to: ROUTE_URLS.home },
  { label: 'For Restaurants', to: ROUTE_URLS.forRestaurants },
  // { label: 'Pricing', to: ROUTE_URLS.pricing },
  { label: 'FAQ', to: ROUTE_URLS.faq },
  { label: 'Contact Me', to: ANCHOR_URLS.contact },
];

export const FOOTER_LEGAL_LINKS: NavigationLink[] = [
  {
    label: 'Privacy Policy',
    to: ROUTE_URLS.privacyPolicy,
  },
  {
    label: 'Terms and Conditions',
    to: ROUTE_URLS.termsAndConditions,
  },
];
